import type { ComponentProps } from "react";
import UnicornScene from "unicornstudio-react";
import { memo, useState } from "react";

export const SafeUnicornScene = memo(function SafeUnicornScene(
  props: ComponentProps<typeof UnicornScene>,
) {
  const [didError, setDidError] = useState(false);

  if (didError) {
    if (props.placeholder) {
      return props.placeholder;
    }
    return null;
  }

  return (
    <UnicornScene
      {...props}
      onError={(e) => {
        if (props.onError) {
          props.onError(e);
        }
        setDidError(true);
      }}
    />
  );
});
